import React from 'react';
import parseInterval from './parse-interval';
import Banner from '../components/Banner';
export default function injectBanner(entities, banner) {
  const {
    interval,
    transform = false
  } = banner;
  const parsedInterval = parseInterval(interval);
  const entitySet = [...entities];
  const bannerElement = transform ? /*#__PURE__*/React.createElement(Banner, banner) : banner;
  entitySet.splice(parsedInterval, 0, bannerElement);
  return entitySet;
}
//# sourceMappingURL=inject-banner.js.map